#import "./form-page-fragment.graphql"
#import "../../../../graphql/fragments/form-stub-fragment.graphql"
#import "../../../../graphql/fragments/next-steps-fragment.graphql"
#import "../../../../graphql/fragments/create-rules-fragment.graphql"

fragment MultiPageFormFragment on Form {
    ...FormStubFragment
    isLiveForm
    publishedFormPreviewUrl
    sharableViewInBrowserLink
    hasUnpublishedChanges
    editableVersion {
        id
        pages {
            ...FormPageFragment
        }
        styles
        redirectUrl
        afterSubmissionText
        hasContactFields
        hasAccountFields
        hasLeadFields
    }
    publishedVersion {
        id
        pages {
            ...FormPageFragment
        }
        styles
        redirectUrl
        afterSubmissionText
    }
    embedSnippet
    type
    spamPreventionType
    createRules {
        ...CreateRulesFragment
    }
    nextSteps {
        ...NextStepsFragment
    }
}
